import { ElementType } from "react";
import styled, { css } from "styled-components";
import { TextStyleProps, textStyles } from "../../shared/textStyles";
import { tombac, TypographyProps } from "../../shared/tombac";
import {
  PropsWithPropStyling,
  propStyling,
} from "../../shared/propStyling/propStyling";

export type TextProps = PropsWithPropStyling<
  TextStyleProps &
    TypographyProps & {
      as?: ElementType;

      /**
       * If true, the text will inherit the parent's styles.
       * Note that variant and size will be ignored when cascade is enabled.
       */
      cascade?: boolean;
    }
>;

export const InlineText = styled.span<TextProps>`
  ${({ cascade }) =>
    !cascade &&
    css`
      all: initial;
      ${tombac.typography.text}
    `}

  && {
    ${textStyles}
    ${propStyling}
  }
`;

export const Text = styled.p<TextProps>`
  ${({ cascade }) =>
    !cascade &&
    css`
      all: initial;
      display: block;
      ${tombac.typography.text}
    `}

  && {
    ${textStyles}
    ${propStyling}
  }
`;
